/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetWarehouseResponse
 */
export interface ResponseGetWarehouseResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponseGetWarehouseResponse
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetWarehouseResponse
     */
    code1?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetWarehouseResponse
     */
    code2?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetWarehouseResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetWarehouseResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetWarehouseResponse
     */
    postalCode?: string;
}

/**
 * Check if a given object implements the ResponseGetWarehouseResponse interface.
 */
export function instanceOfResponseGetWarehouseResponse(value: object): value is ResponseGetWarehouseResponse {
    return true;
}

export function ResponseGetWarehouseResponseFromJSON(json: any): ResponseGetWarehouseResponse {
    return ResponseGetWarehouseResponseFromJSONTyped(json, false);
}

export function ResponseGetWarehouseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetWarehouseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : json['address'],
        'code1': json['code1'] == null ? undefined : json['code1'],
        'code2': json['code2'] == null ? undefined : json['code2'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
    };
}

export function ResponseGetWarehouseResponseToJSON(json: any): ResponseGetWarehouseResponse {
    return ResponseGetWarehouseResponseToJSONTyped(json, false);
}

export function ResponseGetWarehouseResponseToJSONTyped(value?: ResponseGetWarehouseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'code1': value['code1'],
        'code2': value['code2'],
        'id': value['id'],
        'name': value['name'],
        'postal_code': value['postalCode'],
    };
}

